var React = require('react');

function ArrowLeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.76845 12L8 6L1.76845 0L0 1.70274L4.46442 6L0 10.2973L1.76845 12Z","fill":"white"}));
}

ArrowLeftInline.defaultProps = {"width":"8","height":"12","viewBox":"0 0 8 12","fill":"none"};

module.exports = ArrowLeftInline;

ArrowLeftInline.default = ArrowLeftInline;
